import _extends from "@babel/runtime/helpers/extends";
import "cn-next/es/message/style";
import _Message from "cn-next/es/message";
import CNRequest from '@alife/cn-request';
import Login from '@alife/operate-comad-login';
import domainMod from "./domain";
import globalData from "./globalData";
import jsonpAdapter from "./jsonpAdapter";
// let latestCsrfOrder = 0;

function loginOut() {
  if (window._loginUrl) {
    window.location.href = window._loginUrl + "?redirectURL=" + window.encodeURIComponent(window.location.href);
  } else {
    var basicDomain = domainMod.getDomain('auth');
    window.location.href = "//" + basicDomain + "/console/login?redirectURL=" + window.encodeURIComponent(window.location.href);
  }
}
var axios = CNRequest({}, {
  useAxiosClass: true,
  turnOffLog: true
});
axios.interceptors.response.use(function (res) {
  var _error, _errorData$error;
  if (res && res.data && (res.data.success || res.data.isSuccess)) {
    return res.data;
  }
  if (res.error || res.data.error) {
    errorCodeHandle(res.error || res.data.error);
    errorMsgHandle(res.config, res.error || res.data.error);
    return Promise.reject(res.error || res.data.error);
  }
  var error = {};
  if (res.response) {
    error = res.response;
  }
  var errorData = ((_error = error) === null || _error === void 0 ? void 0 : _error.data) || error;
  if (errorData !== null && errorData !== void 0 && errorData.message) {
    errorData.message = "" + errorData.message;
  }
  if (errorData !== null && errorData !== void 0 && errorData.error && errorData !== null && errorData !== void 0 && (_errorData$error = errorData.error) !== null && _errorData$error !== void 0 && _errorData$error.message) {
    var _errorData$error2;
    errorData.error.message = "" + ((_errorData$error2 = errorData.error) === null || _errorData$error2 === void 0 ? void 0 : _errorData$error2.message);
  }
  if (errorData || error) {
    return Promise.reject(errorData || error);
  }
  return Promise.reject({
    response: res
  });
}, function (error) {
  return Promise.reject(error);
});
var login;
function errorCodeHandle(error) {
  if (!error) {
    return;
  }
  var code = "" + ((error === null || error === void 0 ? void 0 : error.code) || '');
  if (code === '401') {
    setTimeout(function () {
      loginOut();
    }, 1000);
  } else if (code === '403' && error !== null && error !== void 0 && error.redirectLocation) {
    setTimeout(function () {
      window.location.href = error.redirectLocation;
    }, 1000);
  }
}
function errorMsgHandle(config, error) {
  if (config === void 0) {
    config = {};
  }
  if (error === void 0) {
    error = {};
  }
  var _config = config,
    isAutoShowErrorMessage = _config.isAutoShowErrorMessage;
  var msg = error.message || "" + (error.code || '');
  if (isAutoShowErrorMessage && msg) {
    _Message.error(msg);
  }
}
function genCsrfTokenStoreKey(domain) {
  return "csrfToken_" + domain;
}
function getApiDomain(requestOption) {
  var domain = location.origin;
  if (requestOption.needCheckCurDomainCsrf) {
    try {
      var urlIns = new URL(requestOption.baseURL || requestOption.url);
      domain = urlIns.origin;
    } catch (e) {
      /* empty */
    }
  }
  return domain;
}
if (typeof window.isWMS === 'undefined') {
  window.isWMS = true;
}
if (window.isWMS) {
  try {
    login = new Login();
    login.subscribe(function () {});
    window._wetLogin = login;
  } catch (err) {
    console.error(err);
  }
} else {
  login = {};
  window._wetLogin = login;
}
var csrfFetingRequestMap = {};
var initCsrfId = {
  api: {
    local: {},
    online: {
      csrf: '/api/csrf'
    }
  },
  getCsrfId: function getCsrfId(domain) {
    var _csrfFetingRequest;
    if (domain === void 0) {
      domain = location.origin;
    }
    var csrfFetingRequest = csrfFetingRequestMap[domain];
    // 添加逻辑，部分域的csrf请求会按照最后个csrf的值为准，但是请求时序可能前面个返回晚，此时按照最新的为准
    if (!csrfFetingRequest) {
      csrfFetingRequest = axios({
        url: (domain + "/api/csrf").replace('//api', '/api'),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          Accept: 'application/json'
        },
        withCredentials: domain !== location.origin
      });
      csrfFetingRequestMap[domain] = csrfFetingRequest;
    }
    return (_csrfFetingRequest = csrfFetingRequest) === null || _csrfFetingRequest === void 0 ? void 0 : _csrfFetingRequest.then(function (res) {
      csrfFetingRequest = undefined;
      var response = res;
      if ((response.success === false || response.isSuccess === false) && response.error) {
        var _response$error = response.error,
          error = _response$error === void 0 ? {} : _response$error;
        var _error$code = error.code,
          code = _error$code === void 0 ? '' : _error$code;
        if (code == '401') {
          setTimeout(function () {
            loginOut();
          }, 1000);
        } else if (code == '403' && error.redirectLocation) {
          setTimeout(function () {
            window.location.href = error.redirectLocation;
          }, 1000);
        }
        return res;
      }
      csrfFetingRequestMap[domain] = null;
      return res === null || res === void 0 ? void 0 : res.data;
    }).then(function (res) {
      var _response$data;
      var response = res;
      var csrfId = (response === null || response === void 0 ? void 0 : response.token) || (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.token) || response;
      globalData.setData(genCsrfTokenStoreKey(domain), csrfId);
    })["catch"](function () {
      csrfFetingRequestMap[domain] = null;
    });
  }
};
var net = {
  getCsrfId: function getCsrfId(callback, domain) {
    if (domain === void 0) {
      domain = location.origin;
    }
    try {
      if (window.isWMS) {
        login.queryUMID();
      }
    } catch (err) {
      console.error(err);
    }
    var storageKey = genCsrfTokenStoreKey(domain);
    if (!globalData.getData(storageKey)) {
      return initCsrfId.getCsrfId(domain).then(function () {
        return callback(globalData.getData(storageKey));
      });
    }
    return callback(globalData.getData(storageKey));
  },
  /**
   * 获得api地址
   * @param apiConfig
   * @param apiName
   * @param module 模块名
   * @returns {*}
   */
  getApi: function getApi(apiConfig, apiName, module) {
    if (typeof apiConfig === 'undefined' || typeof apiName === 'undefined') {
      // console.error('parameter missing!');
      return '';
    }
    var reg = new RegExp(/^(http:\/\/|https:\/\/)/);
    var href = window.location.href;
    if (window._useLocalApi) {
      return apiConfig.local[apiName];
    }
    if (href.indexOf('taobao.net') !== -1 || href.indexOf('cainiao.test') !== -1) {
      // 日常
      if (reg.test(apiConfig.online[apiName])) {
        return apiConfig.online[apiName];
      }
      var dailyHost = domainMod.getHost(module, 'daily');
      return "//" + dailyHost + apiConfig.online[apiName];
    }
    if (href.indexOf('pre.') !== -1 || href.indexOf('pre-') !== -1 || href.indexOf('-stg.') !== -1) {
      // 预发
      if (reg.test(apiConfig.online[apiName])) {
        return apiConfig.online[apiName];
      }
      var preHost = domainMod.getHost(module, 'pre');
      return "//" + preHost + apiConfig.online[apiName];
    }
    if (reg.test(apiConfig.online[apiName])) {
      return apiConfig.online[apiName];
    }
    var proHost = domainMod.getHost(module, 'pro');
    return "//" + proHost + apiConfig.online[apiName];
  },
  /**
   * 根据传入的相对地址url返回全路径url
   * @param url
   * @param module
   * @returns {*}
   */
  getApiByUrl: function getApiByUrl(url, module) {
    if (typeof url === 'undefined') {
      // console.error('parameter missing!');
      return '';
    }
    var reg = new RegExp(/^(http:\/\/|https:\/\/)/);
    var href = window.location.href;
    if (window._useLocalApi || reg.test(url)) {
      return url;
    }
    if (href.indexOf('taobao.net') !== -1 || href.indexOf('cainiao.test') !== -1) {
      // 日常
      var dailyHost = domainMod.getHost(module, 'daily');
      return "//" + dailyHost + url;
    }
    if (href.indexOf('pre.') !== -1 || href.indexOf('pre-') !== -1) {
      // 预发
      var preHost = domainMod.getHost(module, 'pre');
      return "//" + preHost + url;
    }
    var proHost = domainMod.getHost(module, 'pro');
    return "//" + proHost + url;
  },
  replaceUrl: function replaceUrl(paramObj) {
    var param = paramObj;
    var url = param.url;
    if (!param.pathData) {
      return param;
    }
    Object.keys(param.pathData).forEach(function (item) {
      var _param$pathData;
      var value = (_param$pathData = param.pathData) === null || _param$pathData === void 0 ? void 0 : _param$pathData[item];
      if (!value) {
        return;
      }
      var re = new RegExp("\\{\\b(" + item + ")\\b\\}", 'g');
      if (url && url.match(re) != null) {
        url = url.replace(re, value);
        param.url = url;
      }
    });
    return param;
  },
  /**
   * ajax 请求rest接口，contentType写死application/json
   * 支持ajax和jsonp请求
   * @param params
   * @param params.url
   * @param params.method   注意：必须是大写的 GET POST
   * @param params.contentType 注意：访问g.alicdn.com 里面的json文件，需要设置"application/x-www-form-urlencoded"
   * @param params.data
   * @param params.params     // 用于替换路径的参数
   * @param params.type
   * @param params.jsonpCallbackName
   * @param params.withCredentials
   * @param params.timeout
   */
  doAjax: function doAjax(paramsObj) {
    var _this = this;
    var domain = getApiDomain(paramsObj);
    var isSameDomain = domain === location.origin;
    if (window._csrfToken && isSameDomain) {
      globalData.setData(genCsrfTokenStoreKey(domain), window._csrfToken);
    }
    if (!window._useLocalApi && !(window._csrfToken && isSameDomain)) {
      return this.getCsrfId(function () {
        return _this.doAjaxAfterGetRsfId(paramsObj);
      }, domain);
    }
    return this.doAjaxAfterGetRsfId(paramsObj);
  },
  /**
   * 同时发起多个请求
   * @paramObj
   * {
   *    paramsArray: [] // 每一个ajax请求的配置参数，与doAjax保持一致
   * }
   */
  doAjaxAll: function doAjaxAll(paramObj) {
    var _this2 = this;
    var promises = [];
    var paramsArray = paramObj.paramsArray;
    paramsArray.forEach(function (n) {
      return promises.push(_this2.doAjax(n));
    });
    Promise.all(promises).then(function (res) {
      return Promise.resolve(res);
    })["catch"](function (err) {
      return Promise.reject(err);
    });
  },
  doAjaxAfterGetRsfId: function doAjaxAfterGetRsfId(params) {
    if (params === void 0) {
      params = {};
    }
    if (!params.url) {
      return null;
    }
    var domain = getApiDomain(params);

    // const sendTime = new Date().getTime();
    var option = {
      method: 'get',
      url: params.url,
      headers: {
        'Content-Type': 'application/json'
      },
      params: {},
      isAutoShowErrorMessage: false
    };
    // 单据id
    // let bus_id = '';

    if (params.isAutoShowErrorMessage) {
      option.isAutoShowErrorMessage = params.isAutoShowErrorMessage;
    }
    if (params.baseURL) {
      option.baseURL = params.baseURL;
    }
    option.data = {
      csrfId: globalData.getData(genCsrfTokenStoreKey(domain)),
      _csrf: globalData.getData(genCsrfTokenStoreKey(domain))
    };
    if (globalData.getData('uuid')) {
      option.data.uuid = globalData.getData('uuid');
    }

    // 增加本地mockurl前缀配置
    if (params.url) {
      if (window._useLocalApi) {
        var reg = new RegExp(/^(http:\/\/|https:\/\/)/);
        if (window._useLocalApiHost && !reg.test(params.url)) {
          option.url = "" + window._useLocalApiHost + params.url;
        }
      }
    }

    // 单据id
    // if (params.bus_id) bus_id = `${params.bus_id}`;
    // if (params.data && params.data.bus_id) bus_id = `${params.data.bus_id}`;

    if (params.method) option.method = params.method.toLocaleLowerCase();
    if (params.contentType) option.headers['Content-Type'] = params.contentType;
    if (params.withCredentials) option.withCredentials = params.withCredentials;
    // if (params.params) option.params = params.params;
    if (typeof params.timeout !== 'undefined') option.timeout = params.timeout;

    // local test api should use GET method
    if (window._useLocalApi && !window._debugLocalApiHTTPMethod) {
      option.method = 'get';
    }
    if ((params.type || 'json').toLocaleLowerCase() === 'jsonp') {
      option.adapter = jsonpAdapter;
      if (params.jsonpCallbackName) {
        option.callbackParamName = params.jsonpCallbackName;
      }
      Object.assign(option.params, option.data, params.data);
    } else if (option.method.toLocaleLowerCase() === 'get') {
      Object.assign(option.params, option.data, params.data);
    } else {
      option.data.data = params.data || {};
      // option.data = JSON.stringify(option.data);
    }

    if (params.optionProcess && typeof params.optionProcess === 'function') {
      var newOption = params.optionProcess(option);
      Object.assign(option, newOption);
    }
    return axios(option);
  }
};

// 初始化进行一次csrf
initCsrfId.getCsrfId()["catch"](function (e) {
  console.error(e);
});
var middleFn = function middleFn(props) {
  return net.doAjax(props);
};
middleFn.get = function (props) {
  return net.doAjax(_extends({}, props, {
    method: 'get'
  }));
};
middleFn.post = function (props) {
  return net.doAjax(_extends({}, props, {
    method: 'post'
  }));
};
Object.keys(net).forEach(function (key) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  middleFn[key] = net[key];
});
export default middleFn;